import { api } from './axios';
import type { LayoutVisibilityConfig } from '../types/domain';

export const layoutVisibilityApi = {
  get: () =>
    api.get<LayoutVisibilityConfig>('/public/layout-visibility').then((r) => r.data),
  superadminGet: () =>
    api.get<LayoutVisibilityConfig>('/superadmin/layout-visibility').then((r) => r.data),
  update: (config: LayoutVisibilityConfig) =>
    api.put<LayoutVisibilityConfig>('/superadmin/layout-visibility', config).then((r) => r.data),
};
